import React, { useState } from "react";
import "./add-discount-modal.css";
import { ClipLoader } from "react-spinners";
import { showToast } from "../toasts/ToastNotification";
import { createDiscountForAdmin } from "../../api/discount.api";

const AddDiscountModal = ({
  isOpen,
  onClose,
  message,
  title,
  setDiscounts,
  discounts,
}) => {
  const [selectedOption, setSelectedOption] = useState("percentage");
  const [code, setCode] = useState("");
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [minPurchase, setMinPurchase] = useState(0);
  const [limitUsage, setLimitUsage] = useState(0);

  if (!isOpen) return null;

  const handleClose = () => {
    if (loading) return;
    onClose();
  };

  const handleAddDiscount = async () => {
    setLoading(true);

    if (amount <= 0) {
      setLoading(false);
      showToast("Giá trị phải lớn hơn 0", "error");
      return;
    }

    if (selectedOption === "percentage" && amount > 100) {
      setLoading(false);
      showToast("Phần trăm không được lớn hơn 100%", "error");
      return;
    }

    if (!startDate || !endDate) {
      setLoading(false);
      showToast("Vui lòng chọn ngày", "error");
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (end < start) {
      setLoading(false);
      showToast("Ngày kết thúc không được trước ngày bắt đầu", "error");
      return;
    }

    if (limitUsage <= 0) {
      setLoading(false);
      showToast("Số lần sử dụng phải lớn hơn 0", "error");
      return;
    }

    if (minPurchase <= 0) {
      setLoading(false);
      showToast("Đơn hàng tối thiểu phải lớn hơn 0", "error");
      return;
    }
    try {
      const res = await createDiscountForAdmin(
        code,
        selectedOption,
        amount,
        startDate,
        endDate,
        minPurchase,
        limitUsage,
        true
      );

      if (res.success) {
        showToast("Thêm mã giảm giá thành công", "success");
        setDiscounts((prevDiscounts) => [res.data.newDiscount, ...prevDiscounts]);
        onClose();
      }
    } catch (error) {
      showToast(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-discount-modal-overlay">
      <div className="admin-discount-modal">
        <div className="admin-discount-modal-head">
          <h2 className="admin-discount-modal-title">{title}</h2>
          <p className="admin-discount-modal-message">
            {message || "Nhập thông tin để tạo mã giảm giá mới."}
          </p>
        </div>

        <div className="admin-discount-modal-form">
          <div className="admin-discount-modal-field">
            <label>Loại giảm giá</label>
            <select
              className="admin-discount-modal-select"
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
            >
              <option value={"percentage"}>Phần trăm</option>
              <option value={"fixed"}>Giá cố định</option>
            </select>
          </div>

          <div className="admin-discount-modal-field">
            <label>Giá trị giảm</label>
            <input
              className="admin-discount-modal-input"
              type="text"
              value={amount.toLocaleString()}
              placeholder="Nhập giá trị giảm"
              onChange={(e) => setAmount(Number(e.target.value.replace(/\D/g, "")))}
            />
          </div>

          <div className="admin-discount-modal-grid">
            <div className="admin-discount-modal-field">
              <label>Code</label>
              <input
                className="admin-discount-modal-input"
                type="text"
                value={code}
                placeholder="VD: IAMPESMOBILE10"
                onChange={(e) => setCode(e.target.value)}
              />
            </div>
            <div className="admin-discount-modal-field">
              <label>Đơn hàng tối thiểu</label>
              <input
                className="admin-discount-modal-input"
                type="text"
                value={minPurchase.toLocaleString() || 0}
                onChange={(e) => setMinPurchase(Number(e.target.value.replace(/\D/g, "")))}
              />
            </div>
          </div>

          <div className="admin-discount-modal-grid">
            <div className="admin-discount-modal-field">
              <label>Ngày bắt đầu</label>
              <input
                className="admin-discount-modal-input"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="admin-discount-modal-field">
              <label>Ngày kết thúc</label>
              <input
                className="admin-discount-modal-input"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

          <div className="admin-discount-modal-field">
            <label>Giới hạn sử dụng (số lần)</label>
            <input
              className="admin-discount-modal-input"
              type="number"
              value={limitUsage}
              onChange={(e) => setLimitUsage(Number(e.target.value.replace(/\D/g, "")))}
            />
          </div>
        </div>

        <div className="admin-discount-modal-actions">
          <button
            disabled={loading}
            className="admin-discount-modal-btn admin-discount-modal-btn-ghost"
            onClick={handleClose}
          >
            Hủy
          </button>
          <button
            onClick={handleAddDiscount}
            disabled={loading}
            className="admin-discount-modal-btn admin-discount-modal-btn-primary"
          >
            {loading ? <ClipLoader size={18} color="#fff" /> : "Thêm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDiscountModal;
